import { PhoneNumberWithPrefixResponse } from '../api/responses/phone-number-with-prefix.response';
import { PhoneNumberWithPrefix } from '../containers/phone-number-with-prefix/phone-number-with-prefix';
import { executeOrNull, Nillable } from '@web/utils';
import { phoneNumberWithPrefixFromResponse } from './phone-number-with-prefix-from-response';

export const nillablePhoneNumberWithPrefixFromResponse = (
  response: Nillable<PhoneNumberWithPrefixResponse>,
): Nillable<PhoneNumberWithPrefix> => {
  return executeOrNull(response, (response) =>
    phoneNumberWithPrefixFromResponse(response),
  );
};
